import React from "react";
import './style.css'

const LearnMore = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        {/* Section Title */}
        <div className="text-center mb-5">
          <h1 className="display-5">IT Training & Certification Programs</h1>
          <p className="lead">
            Upskill with industry-relevant IT training courses and certifications to boost your career and technical expertise.
          </p>
        </div>

        {/* Why Choose Us Section */}
        <div className="row g-4 mb-5">
          <h2 className="text-center mb-4">Why Choose Our IT Training?</h2>
          <div className="col-lg-6">
            <ul className="list-group">
              <li className="list-group-item">
                <strong>Comprehensive Curriculum:</strong> Learn the most in-demand technologies, including AI, Cloud Computing, and Full Stack Development.
              </li>
              <li className="list-group-item">
                <strong>Hands-On Learning:</strong> Get practical experience with real-world projects and industry scenarios.
              </li>
              <li className="list-group-item">
                <strong>Expert Trainers:</strong> Certified professionals with years of industry experience.
              </li>
              <li className="list-group-item">
                <strong>Job-Ready Certification:</strong> Globally recognized certifications.
              </li>
            </ul>
          </div>
          <div className="col-lg-6">
            <img
              src="https://via.placeholder.com/500x300"
              alt="IT Training"
              className="img-fluid rounded"
            />
          </div>
        </div>

        {/* Course Categories */}
        <div className="mb-5">
          <h2 className="text-center mb-4">Explore Our Course Categories</h2>
          <div className="row g-4">
            <div className="col-lg-6 col-md-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">Programming & Development</h5>
                  <p className="card-text">
                    Learn Python, Java, C#, React, Angular, and Node.js to build scalable web applications.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">Cloud Computing</h5>
                  <p className="card-text">
                    Master AWS, Azure, and Google Cloud with hands-on labs and real-world projects.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">Cybersecurity</h5>
                  <p className="card-text">
                    Learn ethical hacking, penetration testing, and secure coding practices.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">Data Science & AI</h5>
                  <p className="card-text">
                    Dive into data analytics, machine learning, and AI-powered tools like TensorFlow and PyTorch.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials Section */}
        <div className="mb-5">
          <h2 className="text-center mb-4">What Our Students Say</h2>
          <div className="row g-4">
            <div className="col-lg-6">
              <blockquote className="blockquote bg-light p-3 shadow-sm">
                <p>
                  "The training was extremely detailed, and the projects prepared me for real-world scenarios. I got placed at a leading tech firm after completing the course!"
                </p>
                <footer className="blockquote-footer">
                  Aishwarya R., <cite>Full Stack Developer</cite>
                </footer>
              </blockquote>
            </div>
            <div className="col-lg-6">
              <blockquote className="blockquote bg-light p-3 shadow-sm">
                <p>
                  "The instructors were very knowledgeable, and the hands-on approach made learning exciting. I highly recommend these courses for IT professionals."
                </p>
                <footer className="blockquote-footer">
                  Ramesh K., <cite>Cloud Engineer</cite>
                </footer>
              </blockquote>
            </div>
          </div>
        </div>

        {/* Call to Action Section */}
        <div className="text-center">
          <h2 className="mb-4">Ready to Start Your Journey?</h2>
          <div className="d-flex justify-content-center gap-3">
            <button className="btn btn-primary btn-lg">Explore Courses</button>
            <button className="btn btn-success btn-lg">Enroll Now</button>
            <button className="btn btn-outline-secondary btn-lg">Contact Us</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearnMore;
